import { Props_SnippetFact } from "./Fact.props";
import SharedHeading from "../Shared/Heading/Heading";
import SnippetLink from "../Shared/Link/Link";

const SnippetFact = (props: Props_SnippetFact) => {
    const { heading, links, repeatable_links, background } = props;

    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    
    const linkAlignmentClass = links.alignment?.value
        ? `snippet-fact__link-container--${links.alignment.value}`
        : "";
    

    const backgroundClass = background?.background?.value ? `snippet-fact--${background.background.value}` : '';
        
    return (
        <section className={`snippet-fact ${backgroundClass}`}>
            <span className="snippet-fact__top-shape-container"></span>
            <div className="snippet-fact__container">
                <SharedHeading
                    className="snippet-fact__heading"
                    level={headingLevel}
                    alignment={
                        heading.alignment?.value === "start" ||
                        heading.alignment?.value === "center" ||
                        heading.alignment?.value === "end"
                            ? heading.alignment.value
                            : undefined
                    }
                    visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                    data-testid="shared-heading"
                >
                    {heading.text?.value}
                </SharedHeading>
                <div
                    className={`snippet-fact__link-container ${linkAlignmentClass}`}
                >
                    {repeatable_links?.map((link, idx) => {
                        const { linkHref, linkText, linkTarget, linkStyle } = link;
                        return (
                            <SnippetLink
                                key={idx}
                                linkStyles={typeof linkStyle?.value === 'string' ? linkStyle.value : undefined}
                                className="snippet-fact__entry-link"
                                url={typeof linkHref?.value === 'string' ? linkHref.value : undefined}
                                openInNewTab={typeof linkTarget?.value === 'boolean' ? linkTarget.value : linkTarget?.value === 'true'}
                            >
                                {typeof linkText?.value === 'string' ? linkText.value : ''}
                            </SnippetLink>
                        );
                    })}
                </div>
            </div>
            <span className="snippet-fact__bottom-shape-container"></span>
        </section>
    );
};

export default SnippetFact;
